import SvgIcon from "CommonElements/Icons/SvgIcon";
import { sidebarItemType } from "Types/LayoutDataType";
import CustomizerContext from "helper/Customizer";
import layoutContext from "helper/Layout";
import { useRouter } from "next/router";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

type menuListType = {
  MENUITEMS: sidebarItemType[];
  handleActive: (title: string, level: number) => void;
  active: string;
  setActiveLink: Function;
  setActive: Function;
  activeLink: string | undefined;
  level: number;
  className?: string;
};
const Menulist = ({ setActive, handleActive, active, MENUITEMS, level, activeLink, setActiveLink }: menuListType) => {
  const { pinedMenu, setPinedMenu } = useContext(layoutContext);

  useEffect(() => {
    const storedPinedMenu = localStorage.getItem("pinedMenu");
    if (storedPinedMenu) {
      setPinedMenu(JSON.parse(storedPinedMenu));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePined = (value: string | undefined) => {
    if (!pinedMenu.includes(value || "")) {
      localStorage.setItem("pinedMenu", JSON.stringify([...pinedMenu, value || ""]));
      setPinedMenu((data) => [...data, value || ""]);
    } else {
      let filterMenu = pinedMenu.filter((item) => item !== value);
      localStorage.setItem("pinedMenu", JSON.stringify(filterMenu));
      setPinedMenu(filterMenu);
    }
  };

  const router = useRouter();
  const { layoutName } = useContext(CustomizerContext);
  const { t } = useTranslation();

  return (
    <>
      {MENUITEMS.map((item, i) => {
        const itemLastSeg = item.path?.split("/").pop();
        const isChildActive = (() => {
          const check = (children?: sidebarItemType[]): boolean => {
            if (!children) return false;
            return children.some((ch) => {
              const seg = ch.path?.split("/").pop();
              if (seg === activeLink) return true;
              if (ch.children) return check(ch.children);
              return false;
            });
          };
          return check(item.children);
        })();

        const isExpandedActive = item.pathSlice && active.includes(item.pathSlice);
        const isSelfActive = activeLink === itemLastSeg;
        const isActive = isSelfActive || isChildActive || isExpandedActive;

        return (
          <li
            key={i}
            className={`${pinedMenu.includes(item.title || "") ? "pined" : ""} ${level == 0 ? "sidebar-list" : ""} ${isActive && level === 0 ? "active" : ""}`}
          >
            {level === 0 && (
              <i className="fa fa-thumb-tack" onClick={() => handlePined(item.title)}></i>
            )}
            <a
              style={{ cursor: "pointer" }}
              className={
                level === 0
                  ? `sidebar-link sidebar-title ${isActive ? "active" : ""}`
                  : `text-decoration-none ${isActive ? "active" : ""}`
              }
              onClick={() => {
                if (item.type == "sub") {
                  handleActive(item.pathSlice ? item.pathSlice : "", level);
                } else {
                  if (level == 0) {
                    setActive("");
                  }
                  setActiveLink(itemLastSeg);
                  router.push(
                    layoutName
                      ? item.path + `?layout=${layoutName.toLowerCase()}`
                      : `/${item.path}`
                  );
                }
              }}
            >
              {item.icon && (
                <SvgIcon className="stroke-icon" iconId={`stroke-${item.icon}`} />
              )}
              {item.icon && (
                <SvgIcon className="fill-icon" iconId={`fill-${item.icon}`} />
              )}
              <span>{t(`${item.title}`)}</span>
              {item.badge ? <label className={item.badge}>{item.badgetxt}</label> : ""}
              {item.children && (
                <div className="according-menu">
                  {isExpandedActive || isChildActive ? (
                    <i className="fa fa-angle-down" />
                  ) : (
                    <i className="fa fa-angle-right" />
                  )}
                </div>
              )}
            </a>
            {item.children && (
              <ul
                className={` ${level >= 1
                    ? "nav-sub-childmenu submenu-content"
                    : "sidebar-submenu list-group"
                  }`}
                style={
                  (item.pathSlice && active.includes(item.pathSlice)) || isChildActive
                    ? {
                      opacity: "1",
                      transition: "opacity 500ms ease-in 0s",
                      display: "block",
                    }
                    : { display: "none" }
                }
              >
                <Menulist
                  setActive={setActive}
                  MENUITEMS={item.children}
                  handleActive={handleActive}
                  active={active}
                  level={level + 1}
                  activeLink={activeLink}
                  setActiveLink={setActiveLink}
                />
              </ul>
            )}
          </li>
        );
      })}
    </>
  );
};

export default Menulist;
